module.exports = __webpack_public_path__ + "media/images/change-pincode-action-9628e3512a47022c8968a3c6be7fd693.svg";